module.exports = __webpack_public_path__ + "img/link_icon.d26a062e.svg";